import { useAppSelector } from '@/redux/hooks'
import { getAuthState, selectors as sliceSelectors } from '../slice'

export const useUser = () => {
  const state = useAppSelector(getAuthState)
  const userRole = useAppSelector(sliceSelectors.selectUserRole)
  const userRights = useAppSelector(sliceSelectors.selectUserRoleRights)
  const userData = useAppSelector(sliceSelectors.selectUserTokenData)
  const userDelegates = useAppSelector(sliceSelectors.selectUserDelegates)

  const selectors = {
    selectUserRole: () => userRole,
    selectUserRights: () => userRights,
    selectUserData: () => userData,
    selectUserDelegates: () => userDelegates,
  }

  return { ...state, selectors }
}
